import type { AxiosResponse } from "axios";
import { createLogger } from "logging";

const logger = createLogger("helpers/downloads");

export const triggerDownload = (content: BlobPart, fileName: string, contentType: string) => {
  const blob = new Blob([content], { type: contentType });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);

  a.click();
  a.remove();

  window.URL.revokeObjectURL(url);
};

export function getFileName(reponse: AxiosResponse, fileName?: string): string {
  const header = reponse.headers["content-disposition"] || "";

  // Try to match filename* (RFC 5987) which contains UTF-8 encoded special characters
  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
  let result;
  if (utf8Match) {
    result = decodeURIComponent(utf8Match[1]);
    logger.trace(`getFileName(): from utf-8 header:`, result);
    return result;
  }

  // Fallback to regular filename
  const match = header.match(/filename="?([^;]+)"?;?/);
  if (match) {
    result = match[1];
    result = result.replace(/^"+|"+$/g, "");
    logger.trace(`getFileName(): from header`, result);
    return result;
  }

  result = fileName || "unknown.bin";
  result = result.replace(/^"+|"+$/g, "");
  logger.trace(`getFileName(): from default value:`, result);

  return result;
}

export function getContentType(reponse: AxiosResponse, defaultValue = "application/octet-stream"): string {
  const value = reponse.headers["content-type"]?.toString() || defaultValue;
  logger.trace(`getContentType(): `, value);

  return value;
}
